
export class DataFilterViewModel {
    typeInt1:number;
    typeInt2:number;
    typeInt3:number;
    arrayInt1:number[];
    arrayInt2:number[];
    typeString1:string;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/dataFilter.viewModel.ts